import React from 'react';
import PropTypes from 'prop-types';
import TooltipWrapper from 'js/components/global/TooltipWrapper';

const internals = {
  orientation: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
  },
  isMobile: window.innerWidth < 768
};

const RoomIcon = (props) => {

  const {name, tooltipContent, options, withOutName, orientation} = props;
  const {className = '', attributeName = ''} = options;

  return (
    <li className={orientation !== internals.orientation.VERTICAL ? 'd-inline-block' : ''}>
      <TooltipWrapper content={tooltipContent} className="room-icons-popups" useHover={!internals.isMobile}>
        <i className={className || name}/>
        {!withOutName && <span>{attributeName}</span>}
      </TooltipWrapper>
    </li>
  );
};

RoomIcon.propTypes = {
  name: PropTypes.string,
  tooltipContent: PropTypes.element,
  options: PropTypes.shape({
    className: PropTypes.string,
    attributeName: PropTypes.string,
  }),
  withOutName: PropTypes.bool,
  orientation: PropTypes.string,
};

RoomIcon.defaultProps = {
  name: '',
  tooltipContent: '',
  options: {},
  withOutName: false,
  orientation: internals.orientation.HORIZONTAL,
};

export default RoomIcon;



// WEBPACK FOOTER //
// ./js/components/step2/room-icons/RoomIcon.js